module.exports = __webpack_public_path__ + "static/langojango-polish-language-phrasebook-a7737412e243eeb9a081a72b058a74e8.png";